__turbopack_context__.v({
  "exists_warning": "team-signup-form-module-scss-module__rrdwEa__exists_warning",
  "form": "team-signup-form-module-scss-module__rrdwEa__form",
  "link": "team-signup-form-module-scss-module__rrdwEa__link",
  "warning_icon": "team-signup-form-module-scss-module__rrdwEa__warning_icon",
});
